import React, { useState } from 'react';
import './Accordion.scss';

const Accordion = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`accordion${open ? ' open' : ''}`}>
      <button className="accordion__header" onClick={() => setOpen(o => !o)}>
        <span className="accordion__title">{title}</span>
        <span className={`accordion__icon-btn${open ? ' open' : ''}`}></span>
      </button>
      <div className="accordion__body" style={{ display: open ? 'block' : 'none' }}>
        {children}
      </div>
    </div>
  );
};

export default Accordion; 